import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=1a63c530"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports